var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.57,
    height: 173.509,
    viewBox: "0 0 173.57 173.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M55.861,84.05a2.5,2.5,0,0,0-2.531,2.531V96.642h5.061V86.581A2.5,2.5,0,0,0,55.861,84.05Z",
    transform: "translate(30.925 -46.645)",
    fill: "#4f667a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(7.222 85.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M40.85,91.88h40v85.3h-40Z",
    transform: "translate(-40.85 -91.88)",
    fill: "#94d0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M45.41,91.88H57.261v85.3H45.41Z",
    transform: "translate(-17.263 -91.88)",
    fill: "#72bfb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M60.15,91.88h40v85.3h-40Z",
    transform: "translate(58.979 -91.88)",
    fill: "#94d0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M65.53,91.88h6.79v85.3H65.53Z",
    transform: "translate(86.807 -91.88)",
    fill: "#72bfb9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(0.062 83.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M84.317,91.47h-42.1a2.531,2.531,0,0,0,0,5.061h42.1a2.531,2.531,0,0,0,0-5.061Z",
    transform: "translate(-39.69 -91.47)",
    fill: "#aac3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M104.787,91.47h-42.1a2.531,2.531,0,0,0,0,5.061h42.1a2.531,2.531,0,1,0,0-5.061Z",
    transform: "translate(66.191 -91.47)",
    fill: "#aac3d6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M46.5,86.09h89.316V207.071H46.5Z",
    transform: "translate(-4.404 -36.093)",
    fill: "#94d0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M59.88,86.09h6.79V207.071H59.88Z",
    transform: "translate(64.804 -36.093)",
    fill: "#72bfb9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(16.357 94.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M58.811,95.911v18.826a2.5,2.5,0,0,1-2.531,2.531H44.861a2.5,2.5,0,0,1-2.531-2.531V95.911a2.5,2.5,0,0,1,2.531-2.531H56.28A2.5,2.5,0,0,1,58.811,95.911Z",
    transform: "translate(-42.33 -93.38)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M58.811,95.911v9.382H42.33V95.911a2.5,2.5,0,0,1,2.531-2.531H56.28A2.5,2.5,0,0,1,58.811,95.911Z",
    transform: "translate(-42.33 -93.38)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(16.357 125.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M58.811,100.861v24.258a2.5,2.5,0,0,1-2.531,2.531H44.861a2.5,2.5,0,0,1-2.531-2.531V100.861a2.5,2.5,0,0,1,2.531-2.531H56.28A2.5,2.5,0,0,1,58.811,100.861Z",
    transform: "translate(-42.33 -98.33)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M58.811,100.861v9.382H42.33v-9.382a2.5,2.5,0,0,1,2.531-2.531H56.28A2.5,2.5,0,0,1,58.811,100.861Z",
    transform: "translate(-42.33 -98.33)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(140.733 94.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M78.961,95.911v18.826a2.5,2.5,0,0,1-2.531,2.531H65.011a2.5,2.5,0,0,1-2.531-2.531V95.911a2.5,2.5,0,0,1,2.531-2.531H76.43A2.5,2.5,0,0,1,78.961,95.911Z",
    transform: "translate(-62.48 -93.38)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M78.961,95.911v9.382H62.48V95.911a2.5,2.5,0,0,1,2.531-2.531H76.43a2.5,2.5,0,0,1,2.531,2.531Z",
    transform: "translate(-62.48 -93.38)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(140.733 125.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M78.961,100.861v24.258a2.5,2.5,0,0,1-2.531,2.531H65.011a2.5,2.5,0,0,1-2.531-2.531V100.861a2.5,2.5,0,0,1,2.531-2.531H76.43A2.5,2.5,0,0,1,78.961,100.861Z",
    transform: "translate(-62.48 -98.33)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M78.961,100.861v9.382H62.48v-9.382a2.5,2.5,0,0,1,2.531-2.531H76.43a2.5,2.5,0,0,1,2.531,2.531Z",
    transform: "translate(-62.48 -98.33)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(53.824 125.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M64.881,100.861v31.048a2.5,2.5,0,0,1-2.531,2.531H50.931a2.5,2.5,0,0,1-2.531-2.531V100.861a2.5,2.5,0,0,1,2.531-2.531H62.35A2.5,2.5,0,0,1,64.881,100.861Z",
    transform: "translate(-48.4 -98.33)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M64.881,100.861v9.382H48.4v-9.382a2.5,2.5,0,0,1,2.531-2.531H62.35A2.5,2.5,0,0,1,64.881,100.861Z",
    transform: "translate(-48.4 -98.33)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(103.266 125.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M72.891,100.861v31.048a2.5,2.5,0,0,1-2.531,2.531H58.941a2.5,2.5,0,0,1-2.531-2.531V100.861a2.5,2.5,0,0,1,2.531-2.531H70.36a2.5,2.5,0,0,1,2.531,2.531Z",
    transform: "translate(-56.41 -98.33)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M72.891,100.861v9.382H56.41v-9.382a2.5,2.5,0,0,1,2.531-2.531H70.36a2.5,2.5,0,0,1,2.531,2.531Z",
    transform: "translate(-56.41 -98.33)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M68.891,100.861v42.9a2.5,2.5,0,0,1-2.531,2.531H54.941a2.5,2.5,0,0,1-2.531-2.531v-42.9a2.5,2.5,0,0,1,2.531-2.531H66.36A2.5,2.5,0,0,1,68.891,100.861Z",
    transform: "translate(26.166 27.219)",
    fill: "#4f667a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M142.65,85.68H48.211a2.531,2.531,0,0,0,0,5.061H142.65a2.531,2.531,0,0,0,0-5.061Z",
    transform: "translate(-8.645 -38.213)",
    fill: "#aac3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M92.385,93.359v11.234a2.147,2.147,0,0,1-2.16,2.16H79.114V117.8a2.147,2.147,0,0,1-2.16,2.16H65.719a2.147,2.147,0,0,1-2.16-2.16V106.754H52.51a2.147,2.147,0,0,1-2.16-2.16V93.359a2.147,2.147,0,0,1,2.16-2.16H63.559V80.15a2.147,2.147,0,0,1,2.16-2.16H76.953a2.147,2.147,0,0,1,2.16,2.16V91.2h11.11A2.147,2.147,0,0,1,92.385,93.359Z",
    transform: "translate(15.511 -77.99)",
    fill: "#ff6e6e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(87.341 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M61.052,80.15V91.2H55.99V80.15a2.147,2.147,0,0,0-2.16-2.16h5.061A2.147,2.147,0,0,1,61.052,80.15Z",
    transform: "translate(-53.83 -77.99)",
    fill: "#f44e92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M55.99,82.65h5.061V93.7a2.147,2.147,0,0,1-2.16,2.16H53.83a2.147,2.147,0,0,0,2.16-2.16Z",
    transform: "translate(-53.83 -53.886)",
    fill: "#f44e92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M63.212,82.29V93.524a2.147,2.147,0,0,1-2.16,2.16H55.99a2.147,2.147,0,0,0,2.16-2.16V82.29a2.147,2.147,0,0,0-2.16-2.16h5.061A2.147,2.147,0,0,1,63.212,82.29Z",
    transform: "translate(-42.657 -66.921)",
    fill: "#f44e92"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M210.72,105.28H42.211a2.531,2.531,0,0,0,0,5.061H210.72a2.531,2.531,0,0,0,0-5.061Z",
    transform: "translate(-39.68 63.167)",
    fill: "#aac3d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(53.824 89.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M64.881,95.041V119.3a2.5,2.5,0,0,1-2.531,2.531H50.931A2.5,2.5,0,0,1,48.4,119.3V95.041a2.5,2.5,0,0,1,2.531-2.531H62.35A2.5,2.5,0,0,1,64.881,95.041Z",
    transform: "translate(-48.4 -92.51)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M64.881,95.041v9.382H48.4V95.041a2.5,2.5,0,0,1,2.531-2.531H62.35A2.5,2.5,0,0,1,64.881,95.041Z",
    transform: "translate(-48.4 -92.51)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(78.576 89.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M68.891,95.041V119.3a2.5,2.5,0,0,1-2.531,2.531H54.941A2.5,2.5,0,0,1,52.41,119.3V95.041a2.5,2.5,0,0,1,2.531-2.531H66.36A2.5,2.5,0,0,1,68.891,95.041Z",
    transform: "translate(-52.41 -92.51)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M68.891,95.041v9.382H52.41V95.041a2.5,2.5,0,0,1,2.531-2.531H66.36A2.5,2.5,0,0,1,68.891,95.041Z",
    transform: "translate(-52.41 -92.51)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(103.266 89.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M72.891,95.041V119.3a2.5,2.5,0,0,1-2.531,2.531H58.941A2.5,2.5,0,0,1,56.41,119.3V95.041a2.5,2.5,0,0,1,2.531-2.531H70.36a2.5,2.5,0,0,1,2.531,2.531Z",
    transform: "translate(-56.41 -92.51)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M72.891,95.041v9.382H56.41V95.041a2.5,2.5,0,0,1,2.531-2.531H70.36a2.5,2.5,0,0,1,2.531,2.531Z",
    transform: "translate(-56.41 -92.51)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(53.824 59.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M64.881,90.091v18.826a2.5,2.5,0,0,1-2.531,2.531H50.931a2.5,2.5,0,0,1-2.531-2.531V90.091a2.5,2.5,0,0,1,2.531-2.531H62.35A2.5,2.5,0,0,1,64.881,90.091Z",
    transform: "translate(-48.4 -87.56)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M64.881,90.091v9.382H48.4V90.091a2.5,2.5,0,0,1,2.531-2.531H62.35A2.5,2.5,0,0,1,64.881,90.091Z",
    transform: "translate(-48.4 -87.56)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(78.576 59.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M68.891,90.081v18.826a2.5,2.5,0,0,1-2.531,2.531H54.941a2.5,2.5,0,0,1-2.531-2.531V90.081a2.5,2.5,0,0,1,2.531-2.531H66.36A2.5,2.5,0,0,1,68.891,90.081Z",
    transform: "translate(-52.41 -87.55)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M68.891,90.081v9.382H52.41V90.081a2.5,2.5,0,0,1,2.531-2.531H66.36A2.5,2.5,0,0,1,68.891,90.081Z",
    transform: "translate(-52.41 -87.55)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(103.266 59.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M72.891,90.1v18.826a2.5,2.5,0,0,1-2.531,2.531H58.941a2.5,2.5,0,0,1-2.531-2.531V90.1a2.5,2.5,0,0,1,2.531-2.531H70.36A2.5,2.5,0,0,1,72.891,90.1Z",
    transform: "translate(-56.41 -87.57)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M72.891,90.1v9.382H56.41V90.1a2.5,2.5,0,0,1,2.531-2.531H70.36A2.5,2.5,0,0,1,72.891,90.1Z",
    transform: "translate(-56.41 -87.57)",
    fill: "#8aabbf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M68.891,100.861v9.382H52.41v-9.382a2.5,2.5,0,0,1,2.531-2.531H66.36A2.5,2.5,0,0,1,68.891,100.861Z",
    transform: "translate(26.166 27.219)",
    fill: "#8aabbf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.76041592da220671ba76b173dafd6c1d.svg";
export { ForwardRef as ReactComponent };